"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRetry = void 0;
const MAX_RETRIES = 10;
function withRetry(func, args, maxRetries = MAX_RETRIES) {
    return __awaiter(this, void 0, void 0, function* () {
        let retries = 0;
        while (true) {
            try {
                const result = yield func(...args);
                return result;
            }
            catch (error) {
                retries++;
                if (retries > maxRetries) {
                    throw new Error(`Max retries exceeded when executing ${func.name.toLowerCase()}: ${error}`);
                }
            }
        }
    });
}
exports.withRetry = withRetry;
__exportStar(require("./feeManager"), exports);
__exportStar(require("./ha"), exports);
__exportStar(require("./slp"), exports);
__exportStar(require("./spread"), exports);
__exportStar(require("./user"), exports);
//# sourceMappingURL=index.js.map